import compiler from "mson/lib/compiler";

const displayField = (value, name, label = null, props = null) => {
  let nComponent = {
    component: "TextField",
    value: `${value}`,
    name: name,
    disabled: true,
    editable: false,
  };
  if (label) nComponent.label = label;
  if (props)
    nComponent = {
      ...props,
      ...nComponent,
    };
  const returnComponent = compiler.newComponent(nComponent);
  returnComponent.setValue(value);
  return returnComponent;
};

export default displayField;
